/**
 * @generated SignedSource<<0a96f157c9b5349be7561bf7afea6248>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SeoTab_seoable$data = {
  readonly id: string;
  readonly seo: {
    readonly id: string;
    readonly metaDescription: string | null;
    readonly metaTitle: string | null;
    readonly slug: string;
  };
  readonly " $fragmentType": "SeoTab_seoable";
};
export type SeoTab_seoable$key = {
  readonly " $data"?: SeoTab_seoable$data;
  readonly " $fragmentSpreads": FragmentRefs<"SeoTab_seoable">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SeoTab_seoable",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Seo",
      "kind": "LinkedField",
      "name": "seo",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "metaTitle",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "metaDescription",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Seoable",
  "abstractKey": "__isSeoable"
};
})();

(node as any).hash = "e06006d171268859877223a2c40b54cc";

export default node;
